






































































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import moment from 'moment'
import PlantPicker from "@/view/shared-components/PlantPicker.vue";
import DispositionPicker from "@/view/shared-components/DispositionPicker.vue";
import WipTicket from "@/domainObjects/wip/WipTicket";
import SearchWip from "@/domainObjects/wip/SearchWip";
import DefectPicker from "@/view/shared-components/DefectPicker.vue";
import VerificationPicker from "@/view/shared-components/VerificationPicker.vue";
import SubmitTicketButtonGroupMobile from "@/view/shared-components/mobile-only/SubmitTicketButtonGroupMobile.vue";
import SubmitTicketButtonGroupDesktop from "@/view/shared-components/desktop-only/SubmitTicketButtonGroupDesktop.vue";
import DiscrepancyPicker from "@/view/shared-components/DiscrepancyPicker.vue";
import CustomDatePicker from "@/view/shared-components/CustomDatePicker.vue";
import LoadingIndicator from "@/view/shared-components/LoadingIndicator.vue";
import TicketService from "@/services/TicketService";
import StatusPicker from "@/view/shared-components/StatusPicker.vue";


@Component({
    name:'SearchWipTicketPage',
    components: {
        StatusPicker,
        LoadingIndicator,
        CustomDatePicker,
        DiscrepancyPicker,
        SubmitTicketButtonGroupDesktop,
        SubmitTicketButtonGroupMobile,
        VerificationPicker,
        DefectPicker,
        DispositionPicker,
        PlantPicker,}
})
export default class SearchWipTicketPage extends Vue {
    private wipTickets: WipTicket[] = [];
    private search: SearchWip;
    private originalSearchStringified: string;
    private busy: boolean = false;
    private show: boolean = true;
    private allowReset: boolean = false;
    private downloading: boolean = false;

    @Watch('search',{immediate:true, deep:true})
    onPropertyChanged (value: SearchWip, oldvalue: SearchWip) {
        let searchStringified = JSON.stringify(value);
        this.allowReset = this.originalSearchStringified !== searchStringified;
    }

    constructor(){
        super();
        this.search = new SearchWip();
        this.originalSearchStringified = JSON.stringify(this.search);
    }


    onSubmit() {
        this.search.limitResults = true;
        this.busy = true;
        if (!this.search.statuses.includes(2)){
            this.search.closedStartDate = "";
            this.search.closedEndDate = "";
        }
        let searchJSON = JSON.stringify(this.search);
        this.$router.push({name:'wip-search-results', params: { searchJSON: searchJSON }})
    };

    onReset() {
        this.search = new SearchWip();
    }

    selectClosedDateRange(months){
        this.show = false;
        this.search.closedStartDate = new Date(moment().subtract(months, 'month').toDate());
        this.search.closedEndDate = new Date();
        this.$nextTick(() => {
            this.show = true
        });
    }

    selectCreatedDateRange(months){
        this.show = false;
        this.search.createdStartDate = new Date(moment().subtract(months, 'month').toDate());
        this.search.createdEndDate = new Date();
        this.$nextTick(() => {
            this.show = true
        });
    }

    openCsvFile(result, csvFileName){
        if (window.navigator.msSaveBlob) {
            //Internet Explorer
            window.navigator.msSaveBlob(new Blob([result]), csvFileName);
            // @ts-ignore
        } else if (window.webkitURL != null) {
            //Google Chrome and Mozilla Firefox
            let a = document.createElement("a");
            result = encodeURIComponent(result);
            a.href = "data:application/csv;charset=UTF-8," + result;
            a.download = csvFileName;
            a.click();
        } else {
            //Everything Else
            window.open(result);
        }
    }

    generateWipExcelReport(){
        this.downloading = true;
        this.search.limitResults = false;
        let searchJSON = JSON.stringify(this.search);
        TicketService.generateWipExcelReport(searchJSON).then((response) => {
            this.openCsvFile(response.data, "WipTicketSearchResults.csv");
            this.downloading = false;
        }).catch((error) => {

            this.$router.push('/search-wip-ticket')
            alert('error downloading excel file, search criteria may be malformed');
        });
    }
}
